import i18n from '../translations/i18n';
import {
  IObjectAction,
  IObjectTrigger,
  IObjectCondition,
  PlantDetailDTO,
  AlarmTrigger,
  AlarmType,
  AlarmPartitionState,
  ActionDTO,
  TriggerDTO,
  ConditionDTO,
} from '../../../client-generator/generated-clients/plants';

export class SceneAlarmUtils {
  private static $t = i18n.global.t;

  public static getAlarmObjectDescription(
    toc: IObjectTrigger | IObjectCondition | IObjectAction,
    plant: PlantDetailDTO | null = null
  ): string {
    let description = '';
    const alarmTrigger = <AlarmTrigger>toc;
    if (alarmTrigger.alarmType === AlarmType.Partition) {
      description = `${this.$t(
        'AppResource.Partition'
      )} ${SceneAlarmUtils.getAlarmPartitionNameById(
        plant,
        alarmTrigger.alarmPartitionOrSceneId
      )} ${SceneAlarmUtils.getTranslatedStrFromAlarmPartitionState(
        alarmTrigger.alarmPartitionState
      )}`;
    } else {
      description = `${this.$t(
        'AppResource.Alarmsystemscene'
      )} ${SceneAlarmUtils.getAlarmSceneNameById(
        plant,
        alarmTrigger.alarmPartitionOrSceneId
      )}`;
    }
    return description;
  }

  public static getAlarmPartitionNameById(
    currPlant: PlantDetailDTO | null,
    alarmPartId?: string
  ): string {
    const alarmConfiguration = currPlant?.mxServer?.alarmConfiguration;
    if (alarmConfiguration) {
      const currPartition = alarmConfiguration.partitions?.find(
        (a) => a.partitionId == alarmPartId
      );
      return currPartition?.partitionName ?? '';
    }
    return '';
  }

  public static getAlarmSceneNameById(
    currPlant: PlantDetailDTO | null,
    alarmSceneId?: string
  ): string {
    const alarmConfiguration = currPlant?.mxServer?.alarmConfiguration;
    if (alarmConfiguration) {
      const currScene = alarmConfiguration.scenes?.find(
        (a) => a.sceneId == alarmSceneId
      );
      return currScene?.sceneName ?? '';
    }
    return '';
  }

  public static getTranslatedStrFromAlarmPartitionState(
    alarmPartitionState?: AlarmPartitionState
  ): string {
    if (!alarmPartitionState) return '';
    const key = {
      [AlarmPartitionState.Disarmed]: 'AppResource.AlarmPartitionDisarmed',
      [AlarmPartitionState.Exit]: 'AppResource.AlarmPartitionExit',
      [AlarmPartitionState.Armed]: 'AppResource.AlarmPartitionArmed',
      [AlarmPartitionState.PreAlarm]: 'AppResource.AlarmPartitionPreAlarm',
      [AlarmPartitionState.Ready_To_Arm]:
        'AppResource.AlarmPartitionReadyToArm',
      [AlarmPartitionState.Alarm]: 'AppResource.AlarmPartitionAlarm',
      [AlarmPartitionState.Armed_Immediate]:
        'AppResource.AlarmPartitionArmedImmediate',
      [AlarmPartitionState.Tamper]: 'AppResource.AlarmPartitionTamper',
      [AlarmPartitionState.None]: '',
    }[alarmPartitionState];
    return this.$t(key);
  }

  public static getAlarmSceneObjectName(act: ActionDTO | TriggerDTO | ConditionDTO) {
    let params: AlarmTrigger | null = null;
    if (act instanceof ActionDTO) {
      params = <AlarmTrigger>act.actionParams;
    } else if (act instanceof TriggerDTO) {
      params = <TriggerDTO>act.triggerParams;
    } else if (act instanceof ConditionDTO) {
      params = <TriggerDTO>act.conditionParams;
    }
    return `${this.$t('AppResource.Alarmsystem')} ${
      params?.isSuspended ? `(${this.$t('AppResource.Suspended')})` : ''
    }`;
  }
}
